import { useCallback, useRef } from 'react';

type SectionRefreshInfo = {
  queryKey: string[];
  isVisible: boolean;
  refetch: () => void;
  invalidateSection: () => void;
  clearSection: () => void;
};

export const useHomeContestRefresh = () => {
  const sectionsRef = useRef<Map<string, SectionRefreshInfo>>(new Map());
  const registerSection = useCallback((sectionTitle: string, refreshInfo: SectionRefreshInfo) => {
    sectionsRef.current.set(sectionTitle, refreshInfo);

    return () => {
      sectionsRef.current.delete(sectionTitle);
    };
  }, []);

  const getVisibleSectionsCount = useCallback(() => {
    const sections = Array.from(sectionsRef.current.values());
    return sections.filter((section) => section.isVisible).length;
  }, []);

  return {
    registerSection,
    getVisibleSectionsCount,
  };
};
